import { EOrderStatus } from "./types";

export const getColorByStatus = (status?: EOrderStatus) => {
  if (!status) {
    return "gray";
  }
  if (status === EOrderStatus.Cancelled) {
    return "yellow";
  }
  if (status === EOrderStatus.Error) {
    return "red";
  }
  if (status === EOrderStatus.Collected || status === EOrderStatus.Delivered) {
    return "green";
  }
  return "violet";
};

export const getOrderStatusesForFilter = () => {
  return [
    EOrderStatus.Pending,
    EOrderStatus.Queued,
    EOrderStatus.Fetched,
    EOrderStatus.Collecting,
    EOrderStatus.Collected,
    EOrderStatus.Ready,
    EOrderStatus.Delivering,
    EOrderStatus.Delivered,
    EOrderStatus.Error,
    EOrderStatus.Cancelled,
  ];
};
